var React = require('react');

function SliderArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2L32 32L2 62","stroke":"black","strokeWidth":"4"}));
}

SliderArrowRight.defaultProps = {"width":"35","height":"64","viewBox":"0 0 35 64","fill":"none"};

module.exports = SliderArrowRight;

SliderArrowRight.default = SliderArrowRight;
